import React from "react";

export const FaIcon = ({ icon, className = "", onClick, align = "align-middle", title, style }) => (
  <i className={`fa-fw ${icon} ${align} ${className}`} style={style} onClick={onClick} title={title} />
);
